import {Brick, registerBrick} from 'olympe';

export default class RemoveLocalStorage extends Brick {
    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input (key) is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {string} key
     * @param {function()} forwardEvent
     */
    update(context, [key], [forwardEvent]) {
        // Making sure the browser support local storage
        if (typeof Storage !== 'undefined') {
            localStorage.removeItem(key);
            forwardEvent();
        } else {
            throw new Error(`Your browser does not support the window.localStorage API`);
        }
    }
}

registerBrick('017a345b0fb701a040e0', RemoveLocalStorage);
